interface LangCountries {
  [key: string]: string;
}

export default {
  AF: "Afghanistan",
  AL: "Albanien",
  DZ: "Algerien",
  AD: "Andorra",
  AO: "Angola",
  AG: "Antigua und Barbuda",
  AR: "Argentinien",
  AM: "Armenien",
  AU: "Australien",
  AT: "Österreich",
  AZ: "Aserbaidschan",
  BS: "Bahamas",
  BH: "Bahrain",
  BD: "Bangladesch",
  BB: "Barbados",
  BY: "Belarus",
  BE: "Belgien",
  BZ: "Belize",
  BJ: "Benin",
  BT: "Bhutan",
  BO: "Bolivien",
  BA: "Bosnien und Herzegowina",
  BW: "Botswana",
  BR: "Brasilien",
  BN: "Brunei",
  BG: "Bulgarien",
  BF: "Burkina Faso",
  BI: "Burundi",
  KH: "Kambodscha",
  CM: "Kamerun",
  CA: "Kanada",
  CV: "Kap Verde",
  CF: "Zentralafrikanische Republik",
  TD: "Tschad",
  CL: "Chile",
  CN: "Volksrepublik China",
  CO: "Kolumbien",
  KM: "Komoren",
  CG: "Kongo, Republik",
  CD: "Kongo, Demokratische Republik",
  CR: "Costa Rica",
  CI: "Elfenbeinküste",
  HR: "Kroatien",
  CU: "Kuba",
  CY: "Zypern",
  CZ: "Tschechien",
  DK: "Dänemark",
  DJ: "Dschibuti",
  DM: "Dominica",
  DO: "Dominikanische Republik",
  EC: "Ecuador",
  EG: "Ägypten",
  SV: "El Salvador",
  GQ: "Äquatorialguinea",
  ER: "Eritrea",
  EE: "Estland",
  ET: "Äthiopien",
  FJ: "Fidschi",
  FI: "Finnland",
  FR: "Frankreich",
  GA: "Gabun",
  GM: "Gambia",
  GE: "Georgien",
  DE: "Deutschland",
  GH: "Ghana",
  GR: "Griechenland",
  GD: "Grenada",
  GT: "Guatemala",
  GN: "Guinea",
  GW: "Guinea-Bissau",
  GY: "Guyana",
  HT: "Haiti",
  HN: "Honduras",
  HU: "Ungarn",
  IS: "Island",
  IN: "Indien",
  ID: "Indonesien",
  IR: "Iran",
  IQ: "Irak",
  IE: "Irland",
  IL: "Israel",
  IT: "Italien",
  JM: "Jamaika",
  JP: "Japan",
  JO: "Jordanien",
  KZ: "Kasachstan",
  KE: "Kenia",
  KI: "Kiribati",
  KP: "Korea, Nord",
  KR: "Korea, Süd",
  KW: "Kuwait",
  KG: "Kirgisistan",
  LA: "Laos",
  LV: "Lettland",
  LB: "Libanon",
  LS: "Lesotho",
  LR: "Liberia",
  LY: "Libyen",
  LI: "Liechtenstein",
  LT: "Litauen",
  LU: "Luxemburg",
  MK: "Nordmazedonien",
  MG: "Madagaskar",
  MW: "Malawi",
  MY: "Malaysia",
  MV: "Malediven",
  ML: "Mali",
  MT: "Malta",
  MH: "Marshallinseln",
  MR: "Mauretanien",
  MU: "Mauritius",
  MX: "Mexiko",
  FM: "Mikronesien",
  MA: "Marokko",
  MD: "Moldau",
  MC: "Monaco",
  MN: "Mongolei",
  ME: "Montenegro",
  MZ: "Mosambik",
  MM: "Myanmar",
  NA: "Namibia",
  NR: "Nauru",
  NP: "Nepal",
  NL: "Niederlande",
  NZ: "Neuseeland",
  NI: "Nicaragua",
  NE: "Niger",
  NG: "Nigeria",
  NO: "Norwegen",
  OM: "Oman",
  PK: "Pakistan",
  PW: "Palau",
  PA: "Panama",
  PG: "Papua-Neuguinea",
  PY: "Paraguay",
  PE: "Peru",
  PH: "Philippinen",
  PL: "Polen",
  PT: "Portugal",
  QA: "Katar",
  RO: "Rumänien",
  RU: "Russland",
  RW: "Ruanda",
  KN: "St. Kitts und Nevis",
  LC: "St. Lucia",
  VC: "St. Vincent und die Grenadinen",
  WS: "Samoa",
  SM: "San Marino",
  ST: "São Tomé und Príncipe",
  SA: "Saudi-Arabien",
  SN: "Senegal",
  RS: "Serbien",
  SC: "Seychellen",
  SL: "Sierra Leone",
  SG: "Singapur",
  SK: "Slowakei",
  SI: "Slowenien",
  SB: "Salomonen",
  SO: "Somalia",
  ZA: "Südafrika",
  SS: "Südsudan",
  ES: "Spanien",
  LK: "Sri Lanka",
  SD: "Sudan",
  SR: "Suriname",
  SZ: "Eswatini",
  SE: "Schweden",
  CH: "Schweiz",
  SY: "Syrien",
  TJ: "Tadschikistan",
  TZ: "Tansania",
  TH: "Thailand",
  TL: "Osttimor",
  TG: "Togo",
  TO: "Tonga",
  TT: "Trinidad und Tobago",
  TN: "Tunesien",
  TR: "Türkei",
  TM: "Turkmenistan",
  TV: "Tuvalu",
  UG: "Uganda",
  UA: "Ukraine",
  AE: "Vereinigte Arabische Emirate",
  GB: "Vereinigtes Königreich",
  US: "Vereinigte Staaten",
  UY: "Uruguay",
  UZ: "Usbekistan",
  VU: "Vanuatu",
  VE: "Venezuela",
  VN: "Vietnam",
  YE: "Jemen",
  ZM: "Sambia",
  ZW: "Simbabwe"
} as LangCountries;
